var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m62.5 483.55c0 15.898 10 30.051 25 35.352 43.648 15.449 75 57.148 75 106.1 0 48.949-31.352 90.648-75 106.1-15 5.3008-25 19.449-25 35.352v83.551c0 48.352 39.199 87.5 87.5 87.5h900c48.301 0 87.5-39.148 87.5-87.5v-83.551c0-15.898-10-30.051-25-35.352-43.648-15.449-75-57.148-75-106.1 0-48.949 31.352-90.648 75-106.1 15-5.3008 25-19.449 25-35.352v-133.55c0-48.352-39.199-87.5-87.5-87.5h-900c-48.301 0-87.5 39.148-87.5 87.5zm725.9 177.25c-29.301-29.25-76.801-29.25-106.1 0-29.25 29.301-29.25 76.801 0 106.05 29.301 29.301 76.801 29.301 106.1 0 29.25-29.25 29.25-76.75 0-106.05zm-64.898-237.3-300 300c-14.648 14.602-14.648 38.398 0 53 14.602 14.648 38.398 14.648 53 0l300-300c14.648-14.602 14.648-38.398 0-53-14.602-14.648-38.398-14.648-53 0zm-205.8 17.352c-29.301-29.301-76.801-29.301-106.1 0-29.25 29.25-29.25 76.801 0 106.05 29.301 29.25 76.801 29.25 106.1 0 29.25-29.25 29.25-76.801 0-106.05z",
    fill: "#01447a",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucher);
export default __webpack_public_path__ + "static/media/voucher.7454dcd53540d756ae3bcfaceb0807a4.svg";
export { ForwardRef as ReactComponent };